<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.USER' | translate }}</h1>
                <div class="content" *ngIf="userPermissions.includes(permissions.WriteUser)">
                    <div class="content-box">
                        {{
                            'FEATURES.USER.SUBSCRIPTION_INFO'
                                | translate
                                    : {
                                          activeUsers: subscription?.activeUsers,
                                          numOfUsers: subscription?.numOfUsers,
                                          activeReaders: subscription?.activeReaders,
                                          numOfReaders: subscription?.numOfReaders
                                      }
                        }}
                    </div>

                    <button
                        *ngIf="userPermissions.includes(permissions.WriteUser)"
                        (click)="changeResponsible()"
                        type="button"
                    >
                        {{ 'BUTTONS.CHANGE_AGREEMENT_RESPONSIBLE' | translate }}
                    </button>
                    <button *ngIf="canCreateUsers" (click)="openCreateUserModal()" class="primary" type="button">
                        {{ 'BUTTONS.CREATE_USER' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </div>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'firstName'"
            [defaultAscending]="sortKey === 'firstName' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'COLUMNS.FIRST_NAME' | translate"
            (sortChanged)="onSortChange('firstName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'lastName'"
            [defaultAscending]="sortKey === 'lastName' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'COLUMNS.LAST_NAME' | translate"
            (sortChanged)="onSortChange('lastName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'title'"
            [defaultAscending]="sortKey === 'title' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'COLUMNS.TITLE' | translate"
            (sortChanged)="onSortChange('title', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'email'"
            [defaultAscending]="sortKey === 'email' && sortAscending"
            [sort]="true"
            [dynamicWidth]="50"
            [text]="'COLUMNS.EMAIL' | translate"
            (sortChanged)="onSortChange('email', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'phone'"
            [defaultAscending]="sortKey === 'phone' && sortAscending"
            [sort]="true"
            [width]="14"
            [text]="'FEATURES.USER.PHONE' | translate"
            (sortChanged)="onSortChange('phone', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'customerName'"
            [defaultAscending]="sortKey === 'customerName' && sortAscending"
            [sort]="true"
            [width]="14"
            [text]="'FEATURES.USER.CUSTOMER' | translate"
            (sortChanged)="onSortChange('customerName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'numberOfAgreements'"
            [defaultAscending]="sortKey === 'numberOfAgreements' && sortAscending"
            [sort]="true"
            [width]="10"
            [text]="'FEATURES.USER.NUM_OF_AGREEMENTS' | translate"
            (sortChanged)="onSortChange('numberOfAgreements', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'inboxEmail'"
            [defaultAscending]="sortKey === 'inboxEmail' && sortAscending"
            [sort]="true"
            [dynamicWidth]="50"
            [text]="'FEATURES.USER.INCOMING_EMAIL' | translate"
            (sortChanged)="onSortChange('inboxEmail', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'roles'"
            [defaultAscending]="sortKey === 'roles' && sortAscending"
            [width]="20"
            [text]="'COLUMNS.ROLES' | translate"
            (sortChanged)="onSortChange('roles', $event)"
        />
        <app-table-header [align]="align.Center" [width]="8" *appHasPermissions="[permissions.WriteUser]" />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of users$ | async" (click)="openCreateUserModal(item)">
            <td>{{ item.firstName }}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.customerName }}</td>
            <td>{{ item.numberOfAgreements }}</td>
            <td>{{ item.inboxEmail }}</td>
            <td>{{ item.roles | roles }}</td>
            <td class="center" *ngIf="isDeletable(item)">
                <button
                    (click)="confirmDeleteUser($event, item)"
                    class="icon"
                    [ngClass]="{ loading: loadingUserIds.includes(item.id) }"
                >
                    <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                </button>
            </td>
            <td class="center" *ngIf="!isDeletable(item)">&nbsp;</td>
        </tr>
    </ng-container>
</app-table>
